export enum NotificationCategory {
  Request = 'request',
  Status = 'status',
  Info = 'info',
  Other = 'other',
}
